$( document ).ready(function() {

    initVideos();
    initIframeCover();

        $( window ).resize(function() {
          initVideos();
          initIframeCover();
        });


        /* INIT VIDEOS – cover & textbildelement */
        function initVideos() {
          var size;
          if (window.matchMedia('(max-width:580px), (orientation: portrait)').matches) {
            size = 'mobile';
          }
          // else if (window.matchMedia('(max-width:1280px)').matches) {
          //   size = 'small';
          // }
          // else if (window.matchMedia('(max-width:1920px)').matches) {
          //   size = 'medium';
          // }
          else {
            size = 'large';
          }

          $('#coverVideo, .initVideo').each(function() {
            var $video = $(this);
            var src = $video.data(size);

            if (!src) return;

            var currentSrc = $video.find('source').attr('src');
            if (currentSrc === src) return;

            $video.find('source').remove();
            $video.append('<source src=\'' + src + '\' type=\'video/mp4\'>');
            this.load();
          });
        }

        /* IFRAME COVER – scales iframe to fill container like object-fit:cover */
        function initIframeCover() {
          $('.iframe--cover').each(function() {
            var $container = $(this);
            var $iframe = $container.find('iframe');
            if (!$iframe.length) return;

            var cW = $container.width();
            var cH = $container.height();
            var videoRatio = 16 / 9;
            var containerRatio = cW / cH;

            if (containerRatio > videoRatio) {
              $iframe.css({ width: '100%', height: (cW / videoRatio) + 'px' });
            } else {
              $iframe.css({ width: (cH * videoRatio) + 'px', height: '100%' });
            }
          });
        }

});
